const aboutNavData = {
	navTitle: 'About HJ',
	navTitleLink: 'https://www.hostjane.com/',
	navLinks: [
		{ link: 'Jane\'s Story', href: '/about-jane/' },
		{ link: 'Mission + Values', href: '/about' },
		{ link: 'Accept Donations', href: '/wishlist' },
		{ link: 'Become a Seller', href: '/sell' },
	],
	btnText: 'Marketplace',
	btnLink: 'https://www.hostjane.com/marketplace',
};

export default aboutNavData;
